
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { Param } from '../../../models/loyalty-param.model';
import { LoyaltyParamsService } from '../../../services/loyalty/params.service';
import { Permission } from './../../../models/permission.model';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { PermsService } from './../../../services/utils/perms.service';

@Component({
  selector: 'app-loyalty-params',
  templateUrl: './loyalty-params.component.html',
  styleUrls: ['./loyalty-params.component.css']
})
export class LoyaltyParamsComponent implements OnInit {

  selectFilter = KontableComponent.SelectFilter;
  serverPagination = KontableComponent.ServerPagination;
  customFilter = KontableComponent.CustomFilter;
  columsTitles: any;
  params: any;
  showModalDelete = false;
  paramModal: Param;
  listParamGroup: Array<{label: string, value: any}>;
  listStates: Array<{value: string, label: string}>;

  // Mostra tasti di edit, delete e recover
  paramPermissions: Permission;

  newDataAvailable = false;
  render = {
    datatable: false
  }

  constructor(
    private translate: TranslateService,
    public paramService: LoyaltyParamsService,
    private router: Router,
    private srvPermission: PermsService
  ) { }

  ngOnInit() {

    const TRANSLATIONS = this.translate.get([
      'params.description',
      'params.param_group',
      'params.param_item',
      'params.param_order',
      'params.param_functional_code',
      'params.division_id',
      'params.param_code',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'common.status_onlySuspended'
    ]);

    const PERMISSIONS = this.srvPermission.getPermission({ms_base: 'koncentro-loyalty', operation: 'card_def'});

    const PARAMGROUP =  this.paramService.getDistinctParam();

    Observable.zip(
      TRANSLATIONS,
      PERMISSIONS,
      PARAMGROUP
    ).subscribe(([t, resPermissions, resParamGroup]) => {

      this.paramPermissions = resPermissions;

      this.listStates = [];
      this.listStates.push({ label: '', value: null });
      this.listStates.push({ label: t['common.status_notDeleted'], value: '0' });
      this.listStates.push({ label: t['common.status_onlyDeleted'], value: '1' });

      this.listParamGroup = [];
      this.listParamGroup.push({label: '', value: null});

      for (const param of resParamGroup.data ) {
        this.listParamGroup.push({
            label: param.param_group,
            value: param.param_group
        });
      }

      this.columsTitles = {
        description: t['params.description'],
        param_group: t['params.param_group'],
        param_item: t['params.param_item'],
        param_order: t['params.param_order'],
        param_functional_code: t['params.param_functional_code'],
        division_id: t['params.division_id'],
        param_code: t['params.param_code']
      };

      this.render.datatable = true;

  });

  }

  edit(param: Param) {
    this.router.navigate(['/loyalty/params/form/' + param.id]);
  }

  addNew() {
    this.router.navigate(['/loyalty/params/form/']);
  }

  openDeleteModal(param) {
    this.paramModal = param;
    this.showModalDelete = true;
  }

  remove(param) {
    this.paramService.remove(param.id).subscribe( res => {
      this.newDataAvailable = true;
    });
  }
  recover(param) {
    this.paramService.recover(param).subscribe((res) => {
      this.newDataAvailable = true;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-params/loyalty-params.component.ts